import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { createStyles } from './styles';

interface GlobalSidebarsLayoutProps {
  leftSection: ReactNode;
  rightSection: ReactNode;
  centerSection: ReactNode;
  contentStyle?: string;
}

const GlobalSidebarsLayout: React.FC<GlobalSidebarsLayoutProps> = ({
  leftSection,
  centerSection,
  rightSection,
  contentStyle = '',
}) => {
  const classes = createStyles();

  return (
    <div className={classes.layoutWrapper}>
      {leftSection}
      <main className={clsx(classes.content, contentStyle)}>{centerSection}</main>
      {rightSection}
    </div>
  );
};

export default GlobalSidebarsLayout;
